module.exports = __webpack_public_path__ + "img/xy-s.b964ddc9.png";